module.exports = __webpack_public_path__ + "img/EZ(3).7174483e.jpg";